/* eslint-disable no-use-before-define, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import React, { FC, useEffect, useState, useRef } from 'react';
import { Hits, HitsPerPage, Pagination, usePagination } from 'react-instantsearch-hooks-web';
import { HitsPerPageConnectorParamsItem } from 'instantsearch.js/es/connectors/hits-per-page/connectHitsPerPage';
import { GridViewHit, ProductsTable } from './components';
import { withProductHitNormalization } from '../../hoc';
import { AlgoliaProductHit } from '../../types';
import { AlgoliaUtil } from '../../utils';
import { FoundHits } from '../../components';

type ProductsSectionProps = {
  algoliaUtil: AlgoliaUtil;
  mobile: boolean;
};

// eslint-disable-next-line react/display-name
const ProductsSection: FC<ProductsSectionProps> = ({ algoliaUtil, mobile }) => {
  const [view, setView] = useState<'table' | 'grid'>(mobile ? 'grid' : 'table');
  const [initialLoad, setInitialLoad] = useState<number | null>(null);
  const topRef = useRef<HTMLDivElement>(null);
  const { currentRefinement } = usePagination();

  useEffect(() => {
    if (mobile && view === 'table') {
      setView('grid');
    }
  }, [mobile]);

  useEffect(() => {
    if (initialLoad !== null) {
      const top = topRef.current?.offsetTop;

      window.scrollTo({
        top: top ? top - 20 : 0,
        behavior: 'smooth',
      });
    }

    setInitialLoad(currentRefinement);
  }, [currentRefinement]);

  return (
    <div className={`sr-products-section-container ${view}-view`} ref={topRef}>
      <div className="hits-header">
        {mobile ? null : <FoundHits />}
        <div style={{ display: 'flex', gap: '48px', fontSize: '0.9rem' }}>
          {mobile ? null : (
            <div>
              <button onClick={() => setView('table')} style={view === 'table' ? { fontWeight: 'bold' } : {}}>
                {capitalize(theme.locales.tableView)}
              </button>{' '}
              |{' '}
              <button onClick={() => setView('grid')} style={view === 'grid' ? { fontWeight: 'bold' } : {}}>
                {capitalize(theme.locales.gridView)}
              </button>
            </div>
          )}
          <HitsPerPage className="hits-per-page" items={getHitsPerPageItems()} />
        </div>
      </div>

      {view === 'table' ? (
        <ProductsTable normalizeHit={algoliaUtil.normalizeProductHit} />
      ) : (
        <Hits
          hitComponent={({ hit }) =>
            withProductHitNormalization(GridViewHit)({
              hit: hit as unknown as AlgoliaProductHit,
              normalizeHit: algoliaUtil.normalizeProductHit,
              mobile,
            })
          }
        />
      )}

      <Pagination showFirst={false} showLast={false} />
    </div>
  );
};

const getHitsPerPageItems = (): HitsPerPageConnectorParamsItem[] => {
  const values = [16, 32, 64];

  const hitsPerPage = values.map<HitsPerPageConnectorParamsItem>((hitValue) => {
    const itemLabel = `${theme.locales.hitsPerPageLabel.replace('{{ quantity }}', String(hitValue))}`;

    return {
      label: itemLabel,
      value: hitValue,
      default: hitValue === 16,
    };
  });

  return hitsPerPage;
};

const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.substring(1);
};

export default React.memo(ProductsSection);
